"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addOrderAction = addOrderAction;
exports.cancelOrder = cancelOrder;
exports.confirmReceive = confirmReceive;
exports.correctStatus = correctStatus;
exports.createShipmentOrder = createShipmentOrder;
exports.eliminateException = eliminateException;
exports.getAbnormalOrderPage = getAbnormalOrderPage;
exports.getById = getById;
exports.getDiningData = getDiningData;
exports.pay = pay;
exports.pushOrder = pushOrder;
exports.queryPage = queryPage;
exports.receipt = receipt;
exports.shipment = shipment;
exports.update = update;
exports.updatePayNote = updatePayNote;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
//修改订单为收货
function receipt(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/receipt',
    method: 'post',
    data: data
  });
}

//修改订单为发货
function shipment(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/shipment',
    method: 'post',
    data: data
  });
}

//修改订单为已支付
function pay(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/pay',
    method: 'post',
    data: data
  });
}

//创建发货单
function createShipmentOrder(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/createShipmentOrder',
    method: 'post',
    data: data
  });
}

//取消订单
function cancelOrder(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/cancelOrder',
    method: 'post',
    data: data
  });
}

//添加备注
function addOrderAction(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/addOrderAction',
    method: 'post',
    data: data
  });
}
function update(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/updateXyOrderInfo',
    method: 'post',
    data: data
  });
}
function updatePayNote(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/updatePayNote',
    method: 'post',
    data: data
  });
}
// 查询菜单分类id
function getById(orderId) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/' + orderId,
    method: 'get'
  });
}

// 订单列表
function queryPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/page',
    method: 'get',
    params: query
  });
}

// 修正订单状态
function correctStatus(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/correctStatus',
    method: 'post',
    data: data
  });
}

// 推送订单
function pushOrder(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/pushOrder',
    method: 'post',
    data: data
  });
}

// 确认收货
function confirmReceive(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/confirmReceive',
    method: 'post',
    data: data
  });
}

// 消除异常
function eliminateException(data) {
  return (0, _requestPIM.default)({
    url: '/xyOrderInfo/eliminateException',
    method: 'post',
    data: data
  });
}

// 查询异常订单日志列表
function getAbnormalOrderPage(query) {
  return (0, _requestPIM.default)({
    url: '/xyAbnormalOrderInfo/page',
    method: 'get',
    params: query
  });
}

// 查询订单的点餐数据详情（按用户分组）
function getDiningData(orderId) {
  return (0, _requestPIM.default)({
    url: "/xyOrderGoods/diningData/".concat(orderId),
    method: 'get'
  });
}